<template>
  <b-section-loader :loading="$loading.isLoading('userDelegationAgreements')">
    <div class="d-flex align-center ga-3">
      <div class="icon">
        <span>✓</span>
      </div>
      <div class="d-flex flex-column">
        <span class="font-weight-bold font-size-18">Погодження</span>
        <span class="text-disabled font-size-13">
          {{ getPersonName(delegation.user) }} · {{ items.length }} документ(ів)
        </span>
      </div>
    </div>
    <v-data-table
      :headers="delegationDocumentListHeaders"
      :items="items"
      :items-per-page="-1"
      class="mt-3 cursor-pointer"
      hide-default-footer
      @click:row="
        (_: any, { item }: any) =>
          $router.push({
            name: 'delegation-document',
            params: { delegationId: delegationId, docId: item.id }
          })
      ">
      <template #item.name="{ item }">
        <router-link
          :to="{
            name: 'delegation-document',
            params: { delegationId: delegationId, docId: item.id },
          }"
          @click.stop>
          {{ item.registrationNumber || item.definition?.name || '—' }}
        </router-link>
      </template>
      <template #item.uuid="{ item }">
        {{ item.uuid || '—' }}
      </template>
      <template #item.class="{ item }">
        {{ item.docTypeClass?.name || '—' }}
      </template>
      <template #item.created_at="{ item }">
        {{
          item.registrationDate
            ? new CustomDate(item.registrationDate).toString()
            : new CustomDate(item.created_at).toString()
        }}
      </template>
      <template #item.status="{ item }">
        {{ item.status }}
      </template>
    </v-data-table>
  </b-section-loader>
</template>

<script lang="ts">
import { ref } from 'vue'
import { delegationDocumentListHeaders } from '@/utils/tableHeaders'
import { userDelegationAgreements } from '@/requests/user'
import { useDelegation } from '../index'
import { CustomDate } from 'best-modules/utils'
import { BSectionLoader } from 'best-modules/components'
import { getPersonName } from 'best-modules/utils/helpers'

export default {
  name: 'DelegationAgreements',
  components: { BSectionLoader },
  data() {
    return {
      delegationDocumentListHeaders,
    }
  },
  methods: { CustomDate, getPersonName },
  setup() {
    const { delegation, delegationId } = useDelegation()
    const items = ref<any[]>([])

    const getAgreements = () => {
      return userDelegationAgreements(delegationId.value).then(res => {
        items.value = res
      })
    }

    getAgreements()

    return { items, delegation, delegationId }
  },
}
</script>

<style lang="scss" scoped>
.icon {
  width: 40px;
  height: 40px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  background: rgba(25, 118, 210, 0.12);
}
</style>
